const header = document.querySelector('.header__columns');
const outerHeader = document.querySelector('.header');

window.addEventListener('scroll', () => {
  if (window.scrollY > 40) {
    header.classList.add('is-shrunk');
    outerHeader.classList.add('has-border');
  } else {
    header.classList.remove('is-shrunk');
    outerHeader.classList.remove('has-border');
  }
});



(function () {
  function addShippingAccordion() {
    const totals = document.querySelector('.cart__summary-totals');
    if (!totals) return;

    if (totals.querySelector('.cart-shipping-returns-js')) return;

    const el = document.createElement('div');
    el.className = 'cart-shipping-returns-js';
    el.innerHTML = `
      <button class="shipping-toggle" type="button">
        Shipping & Returns ▼
      </button>
      <div class="shipping-content">
        <p>
          We offer reliable shipping and hassle-free returns.
          All equipment is rigorously tested for safety and durability.
        </p>
        <a href="/policies/shipping-policy">Read full policy</a>
      </div>
    `;

    totals.appendChild(el);
  }

  // Observe cart changes
  const observer = new MutationObserver(addShippingAccordion);
  observer.observe(document.body, { childList: true, subtree: true });

  // Initial attempt
  addShippingAccordion();

  // Accordion toggle
  document.addEventListener('click', function (e) {
    const toggle = e.target.closest('.shipping-toggle');
    if (!toggle) return;

    const content = toggle.nextElementSibling;
    const open = content.classList.toggle('is-open');

    toggle.textContent = open
      ? 'Shipping & Returns ▲'
      : 'Shipping & Returns ▼';
  });
})();




(function () {
    const ALLOWED_COUNTRY = 'GB';
    const SELECTORS = [
      '.AOV-UpsellProducts__Container',        // upsell in drawer
      '.AOV-CartDrawer-RewardBar__Container', // reward bar in drawer
      '.tinker-upsell-section'                 // upsell on cart page
    ];

    function applyVisibility(source = 'check') {
      console.log('[AOV VISIBILITY]', source, 'Country:', window.Shopify?.country);

      if (window.Shopify?.country !== ALLOWED_COUNTRY) {
        SELECTORS.forEach(selector => {
          document.querySelectorAll(selector).forEach(el => {
            el.style.setProperty('display', 'none', 'important');
            console.log('→ hidden:', selector);
          });
        });
      }
    }

    applyVisibility('initial');

    const observer = new MutationObserver(() => {
      applyVisibility('mutation');
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();